/* eslint-disable prettier/prettier */

export default {
  "yesterday": "gisteren",
  "Something went wrong": "Er is iets fout gegaan",
  "Try again": "Probeer het opnieuw",
  "No messages yet": "Nog geen berichten",
  "Your conversations": "Jouw gesprekken",
  "Unread": "Ongelezen",
  "Attachment sent": "Bijlage verzonden",
  "A call started": "Er is een oproep gestart",
  "Connecting ...": "Verbinden ...",
  "Loading ...": "Bezig met laden ...",
  "Success": "Succes",
  "Error": "Fout",
  "Warning": "Waarschuwing",
  "Layout": "Indeling",
  "Settings changed successfully": "Instellingen succesvol gewijzigd",
  "News": "Nieuws",
  "Agenda": "Agenda",
  "Join the debate": "Doe mee aan het debat",
  "Gallery": "Galerij",
  "Move Up": "Ga omhoog",
  "Move Down": "Naar beneden verplaatsen",
  "Cancel": "Annuleren",
  "Save": "Bewaren",
  "Saving...": "Bewaren...",
  "Content Layout": "Inhoudsopmaak",
  "Control the layout of the content on your portal here.": "Beheer hier de lay-out van de inhoud op uw portaal.",
  "Drawers": "Lades",
  "Manage the drawers that appear on your portal": "Beheer de lades die op uw portaal verschijnen",
  "Enable": "Inschakelen",
  "Disable": "Uitschakelen",
  "All fields are required": "Alle velden zijn verplicht",
  "Add Drawer": "Lade toevoegen",
  "Delete": "Verwijderen",
  "Enter the name of your drawer ...": "Voer de naam van uw lade in ...",
  "Enter the URL of your drawer ...": "Voer de URL van uw lade in ...",
  "You don't have enough permissions to see this page": "Je hebt niet genoeg rechten om deze pagina te zien",
  "This page is accessible only in 'Community' mode": "Deze pagina is alleen toegankelijk in de modus 'Gemeenschap'",
  "Invalid URL": "Ongeldige URL",
};



// WEBPACK FOOTER //
// ./src/i18n/nl.js